/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GoogleProtobufDurationFromJSON, GoogleProtobufDurationToJSON, } from './';
export function StreemInternalApiGroupReservationWaitMetricsFromJSON(json) {
    return StreemInternalApiGroupReservationWaitMetricsFromJSONTyped(json, false);
}
export function StreemInternalApiGroupReservationWaitMetricsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'averageCallLength': !exists(json, 'average_call_length') ? undefined : GoogleProtobufDurationFromJSON(json['average_call_length']),
        'estimatedWaitTime': !exists(json, 'estimated_wait_time') ? undefined : GoogleProtobufDurationFromJSON(json['estimated_wait_time']),
        'queuePosition': !exists(json, 'queue_position') ? undefined : json['queue_position'],
    };
}
export function StreemInternalApiGroupReservationWaitMetricsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'average_call_length': GoogleProtobufDurationToJSON(value.averageCallLength),
        'estimated_wait_time': GoogleProtobufDurationToJSON(value.estimatedWaitTime),
        'queue_position': value.queuePosition,
    };
}
//# sourceMappingURL=StreemInternalApiGroupReservationWaitMetrics.js.map